import { Controller } from "@hotwired/stimulus";
import { useTransition } from "stimulus-use";
import { useEmitter } from "@/emitter"

export default class extends Controller {
    // static classes = [
    //     'symbol'
    // ]

    // connect() {
    //     this.element
    // }
}
